var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0Z",
  "data-name": "Path 222"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#111820",
  d: "M19.086 13.049h-6.037v6.037h-2.012v-6.037H5v-2.012h6.037V5h2.012v6.037h6.037Z",
  "data-name": "Path 5416"
})));
export { SvgPlus as ReactComponent };
export default "/_next/static/images/plus.svg";